<template>
  <section class="container justify-content-center">
    <Observer name="fade-up">
      <div class="text-center">
        <h2 class="title -upper">{{ item.title }}</h2>
      </div>
      <div class="content" ref="content">
        <div v-for="(item, i) in items" :key="i">
          <strong v-text="item.title" class="h3"></strong>
          <p v-html="item.text"></p>
        </div>
      </div>
      <div class="content row justify-content-center">
        <div ref="colLeft" class="col-12 col-md-4"></div>
        <div ref="colRight" class="col-12 col-md-4 offset-md-1"></div>
      </div>
      <div class="btn-sheet" v-if="item && item.pdf">
        <a :href="item.pdf" target="_blank" rel="noreferrer noopener" class="btn" @click="callGTM">{{ $t('Download product sheet') }}</a>
      </div>
    </Observer>
  </section>
</template>

<script>
import { ReadyHook } from 'vue-asyncready'
import config from 'config'

export default {
  props: ['item', 'items', 'pagePosition', 'siblings-components'],
  name: 'technical_specification_manual',
  mixins: [ReadyHook],
  data() {
    return {
      colLeftHeight: 0,
      colRightHeight: 0
    }
  },
  computed: {
    fileUrl() {
      return config.magento2.fileUrl
    }
  },
  mounted () {
    this.splitContent()
  },
  methods: {
    splitContent() {
      this.$refs.content.querySelectorAll('div').forEach((div, i) => {
        if (this.colLeftHeight <= this.colRightHeight) {
          this.$refs.colLeft.appendChild(div)
          this.colLeftHeight += div.offsetHeight
        } else {
          this.$refs.colRight.appendChild(div)
          this.colRightHeight += div.offsetHeight
        }
      })
    },
    callGTM() {
      this.$gtm.trackEvent({
        event: 'download',
        productName: this.$route.params.uid
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/core';

section {
  margin-top: 6rem;
  margin-bottom: 6rem;
  color: var(--zenith-component-text);
}

.-icons .title {
  display: inline;
  color: var(--zenith-white) !important;
  background: var(--zenith-theme-primary) !important;
  box-shadow: -2px 0px 0px 6px var(--zenith-theme-primary);
}

.content {
  margin-top: 6rem;

  &.row {
    .col-12:first-child {
      text-align: right;
      @include bp(max md) {
        text-align: center;
      }
    }
    .col-12 {
      @include bp(max md) {
        text-align: center;
      }
    }
  }

  strong {
    display: block;
    margin-bottom: .5rem;
  }

  p {
    color: var(--zenith-grey);
    margin-bottom: 3rem;
  }
}

</style>
